export function projectDetailPage(): string {
  return `
    <div class="min-h-screen">
      <!-- Back navigation -->
      <div class="container-wide py-8">
        <a href="#/projects" class="inline-flex items-center gap-2 font-body font-medium text-body-sm py-2 transition-colors" style="color: var(--color-primary)">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"></path>
          </svg>
          Retour aux projets
        </a>
      </div>

      <!-- Project Hero -->
      <section class="container-wide pb-12 anim-reveal" aria-labelledby="project-title">
        <div class="card overflow-hidden">
          <div class="aspect-[16/9] sm:aspect-[2/1] overflow-hidden" style="background-color: var(--bg-subtle);">
            <img src="${document.querySelector('[data-asset="plan-de-travail"]')?.getAttribute('src') || ''}"
                 alt="Apercu du dashboard de planification"
                 class="w-full h-full object-cover"
                 loading="eager"
                 onerror="this.style.display='none'; this.parentElement.innerHTML='<div class=\\'flex items-center justify-center h-full\\' style=\\'color: var(--text-tertiary)\\'>Image indisponible</div>'">
          </div>
          <div class="p-6 sm:p-10">
            <div class="flex flex-wrap gap-2 mb-4">
              <span class="tag">UX/UI Design</span>
              <span class="tag">Dashboard</span>
              <span class="tag">Planification</span>
              <span class="tag">Automatisation</span>
            </div>
            <h1 id="project-title" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Dashboard de planification</h1>
            <p class="font-body text-body-lg max-w-3xl" style="color: var(--text-secondary)">
              Dashboard de planification annuelle des pesees avec automatisation hebdomadaire et suivi des ecarts pour les agents terrain et eleveurs.
            </p>
          </div>
        </div>
      </section>

      <!-- Project Details -->
      <section class="container-wide pb-20" aria-label="Details du projet">
        <div class="grid md:grid-cols-2 gap-6">

          <!-- Presentation -->
          <div class="card p-6 sm:p-8 anim-reveal delay-1">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Presentation du projet</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              Conception d'un nouveau dashboard de planification annuelle des pesees et du materiel associe. Cible : agents terrain et eleveurs ; objectif : planifier, executer automatiquement chaque semaine, suivre les ecarts.
            </p>
            <div class="p-4 rounded-xl border-l-4" style="border-color: var(--color-primary); background-color: rgba(67, 56, 202, 0.04);">
              <p class="font-body text-body-sm" style="color: var(--text-secondary)">
                <strong style="color: var(--text-primary)">Portee :</strong> Reponse a AO, maquettes livrees en 2 semaines.
              </p>
            </div>
          </div>

          <!-- Probleme & Objectif -->
          <div class="card p-6 sm:p-8 anim-reveal delay-2">
            <h2 class="font-display font-bold text-body-lg mb-4" style="color: var(--text-primary)">Probleme & Objectif</h2>
            <p class="font-body text-body-md mb-4" style="color: var(--text-secondary)">
              L'outil existant ne gerait pas bien les contraintes croisees (disponibilites agents/eleveurs, protocoles, materiel), generant conflits et perte de temps.
            </p>
            <div class="p-4 rounded-xl border-l-4 border-green-500" style="background-color: rgba(34, 197, 94, 0.04);">
              <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--text-primary)">Objectifs</h3>
              <ul class="space-y-1 font-body text-body-sm" style="color: var(--text-secondary)" role="list">
                <li>Reduire les conflits de planning</li>
                <li>Automatiser l'ordonnancement hebdo</li>
                <li>Fiabiliser le suivi</li>
              </ul>
            </div>
          </div>

          <!-- Design & Solutions -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-3">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Design final & Solutions</h2>
            <div class="grid sm:grid-cols-2 gap-4">
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Vue Plan</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Grille avec filtres, densite ajustable, et indicateurs de saturation</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Generation automatique</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Hebdomadaire avec journal d'ordonnancement et motifs de decisions</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Suivi des ecarts</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Alertes, replanification rapide, historique horodate</p>
              </div>
              <div class="p-5 rounded-xl" style="background-color: var(--bg-subtle);">
                <h3 class="font-display font-semibold text-body-sm mb-2" style="color: var(--color-primary)">Details intervention</h3>
                <p class="font-body text-body-sm" style="color: var(--text-secondary)">Protocole, materiel, contraintes, distance estimee</p>
              </div>
            </div>
          </div>

          <!-- Resultats -->
          <div class="card p-6 sm:p-8 md:col-span-2 anim-reveal delay-4">
            <h2 class="font-display font-bold text-body-lg mb-6" style="color: var(--text-primary)">Resultats & Reflexion</h2>
            <div class="grid sm:grid-cols-3 gap-6">
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(34, 197, 94, 0.1);">
                  <svg class="w-6 h-6" style="color: #22C55E" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Baisse des conflits</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">de planning</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(67, 56, 202, 0.08);">
                  <svg class="w-6 h-6" style="color: var(--color-primary)" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Gain de temps</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">sur la preparation hebdo</p>
              </div>
              <div class="text-center">
                <div class="w-12 h-12 rounded-full mx-auto mb-3 flex items-center justify-center" style="background-color: rgba(168, 85, 247, 0.08);">
                  <svg class="w-6 h-6" style="color: #A855F7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                </div>
                <p class="font-display font-semibold text-body-sm" style="color: var(--text-primary)">Meilleure tracabilite</p>
                <p class="font-body text-body-sm" style="color: var(--text-tertiary)">des ecarts</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-20 sm:py-28" style="background-color: var(--bg-subtle);" aria-labelledby="detail-cta">
        <div class="container-narrow text-center anim-reveal">
          <span class="section-label">Collaboration</span>
          <h2 id="detail-cta" class="font-display font-bold text-display-lg mb-4" style="color: var(--text-primary)">Interesse par ce projet ?</h2>
          <p class="font-body text-body-lg mb-10 max-w-lg mx-auto" style="color: var(--text-secondary)">Discutons de vos besoins en design</p>
          <a href="mailto:arthur.miconnet1@gmail.com" class="btn-primary">
            <span>Me contacter</span>
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
          </a>
        </div>
      </section>
    </div>
  `;
}
